import { useMeQuery } from '@graphql/queries/__generated__/me.generated'
import { Button, Theme } from '@mui/material'
import { buttonClasses } from '@mui/material/Button'
import Divider from '@mui/material/Divider'
import makeStyles from '@mui/styles/makeStyles'
import React from 'react'
import { useQueryParams } from 'use-query-params'
import { GlobalDialogFormsParams } from '../../GlobalDialogForms'
import { useTranslation } from 'react-i18next'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'

const useStyles = makeStyles((theme: Theme) => ({
  button: {
    [`&.${buttonClasses.root}`]: {
      justifyContent: 'space-between',
      height: 60,
      padding: '0 0 0 24px',
      fontWeight: 700,
      fontSize: 16,
      textTransform: 'initial',
      color: theme.palette.secondary.main,
    },
  },
  accountButton: {
    [`&.${buttonClasses.root}`]: {
      justifyContent: 'space-between',
      height: 30,
      padding: '0 0 0 24px',
      fontSize: 14,
      textTransform: 'initial',
      color: theme.palette.secondary.main,
    },
  },
  signInButton: {
    [`&.${buttonClasses.root}`]: {
      fontWeight: 700,
      letterSpacing: '1px',
      fontSize: 14,
      boxShadow: 'none',
    },
  },
  closeIcon: {
    position: 'absolute',
    top: 5,
    right: 5,
    fontSize: 24,
  },
}))

const MenuAccount: React.FC<{
  setIsActiveAccount(val: boolean): void
}> = ({ setIsActiveAccount }) => {
  const { t } = useTranslation()
  const classes = useStyles()
  const [, setParams] = useQueryParams(GlobalDialogFormsParams)
  const { data: dataMe, loading } = useMeQuery()

  return (
    <div style={{ backgroundColor: 'rgb(247, 247, 247)' }}>
      {dataMe?.me && (
        <Button
          className={classes.button}
          variant='text'
          onClick={() => setIsActiveAccount(true)}
          disableRipple
          fullWidth
        >
          <span>{t('myAccount', 'My Account')}</span>
          <ChevronRightIcon fontSize='large' className='mr-10' />
        </Button>
      )}
      {!dataMe?.me && !loading && (
        <div>
          <div className='px-12 py-10'>
            <Button
              className={classes.signInButton}
              variant='contained'
              color='secondary'
              onClick={() => setParams({ global_dialog_form: 'signIn' }, 'replaceIn')}
              disableRipple
              fullWidth
            >
              {t('signIn', 'Sign in')}
            </Button>
          </div>
          <Divider />
          <div className='py-12 px-24 text-black text-base'>
            <div>
              <span className='font-semibold'>{t('notAMember', 'Not a member?')}</span>
              <Button
                variant='text'
                color='secondary'
                onClick={() => setParams({ global_dialog_form: 'signUp' }, 'replaceIn')}
                disableRipple
              >
                <span className='font-semibold text-capitalize'>{t('signUpNow', 'Sign up Now')}</span>
              </Button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default MenuAccount
